import { LookupService } from '../../shared/services/lookup.service';
import { JobseekerService } from '../shared/services/jobseeker.service';
import { JobseekerEducationModel } from '../shared/models/jobseeker-education-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-jobseeker-education-item',
  templateUrl: './jobseeker-education-item.component.html',
  styleUrls: ['./jobseeker-education-item.component.less'],
  standalone: false,
})
export class JobseekerEducationItemComponent implements OnInit {
  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input()
  public education: JobseekerEducationModel;

  public monthListShortMap: any;

  public isEditModeOn: boolean;

  public get item() {
    return this.education;
  }

  constructor(
    private lookupService: LookupService,
    private jobseekerService: JobseekerService,
    private translateService: TranslateService
  ) {}

  public getDownloadUrl() {
    return this.jobseekerService.getEducationAttachmentDownloadUrl(
      this.education.jobseekerId,
      this.education.jobseekerEducationId
    );
  }

  public onDownloadEducationAttachmentClick(formId: string) {
    let form = <any>document.getElementById(formId);
    form.submit();
  }

  public onEditEducationClick() {
    this.isEditModeOn = true;
  }

  public onCancelEditEducation() {
    this.isEditModeOn = false;
  }

  public onEducationEdited() {
    this.onUpdate.emit(true);
  }

  public onDeleteEducationClick() {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.jobseekerService
        .deleteJobseekerEducation(this.education)
        .subscribe((r) => {
          this.onUpdate.emit(true);
        });
    }
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    this.monthListShortMap = lookupData.monthListShort.reduce((a, b) => {
      a[b.value] = b.text;
      return a;
    }, {});
  }
}
